import React from "react"
import PropTypes from "prop-types"

import SignUpContainer from "./SignUpContainer"
import IndividualStep2QuestionnaireForm from "../../forms/SignUpForms/IndividualStep2QuestionnaireForm"
import SignUpWizard from "../../components/SignUpWizard"

function SignUpIndividualStep2Container({
  onHandleNext,
  onBack,
  handleSaveQuestionnaire,
  questionnaireData,
  lockedInfo,
}) {
  return (
    <SignUpContainer
      title="Sign Up Process"
      subtitle="Questionnaire"
      description="Complete the brief questionnaire"
      onBack={onBack}
      onNext={onHandleNext}
      isButtonSubmit
      useVerticalLayout={true}
      currentStep={2}
      userRole="individual"
      lockedInfo={lockedInfo}
    >
      <SignUpWizard userType="individual" />

      <IndividualStep2QuestionnaireForm
        handleSaveQuestionnaire={handleSaveQuestionnaire}
        initialValues={questionnaireData}
      />
    </SignUpContainer>
  )
}

SignUpIndividualStep2Container.propTypes = {
  user: PropTypes.object,
  onHandleNext: PropTypes.func,
  onHandleRole: PropTypes.func,
  lockedInfo: PropTypes.array,
}

export default SignUpIndividualStep2Container
